export default "__VITE_ASSET__CLREuv88__"